// import React, { useEffect, useState } from "react";
// import axios from "axios";

// export default function CustomerDetails() {
//   const [customers, setCustomers] = useState([]);
//   const [searchTerm, setSearchTerm] = useState("");

//   useEffect(() => {
//     axios
//       .get("http://localhost/murugan/retail/retail_get.php")
//       .then((res) => {
//         setCustomers(Array.isArray(res.data) ? res.data : []);
//       })
//       .catch((err) => {
//         console.error("Failed to fetch data:", err);
//       });
//   }, []);

//   const filteredCustomers = customers
//     .filter((cust) =>
//       cust.customer_mobile?.toLowerCase().includes(searchTerm.toLowerCase())
//     )
//     .sort((a, b) => {
//       if (a.customer_mobile === searchTerm) return -1;
//       if (b.customer_mobile === searchTerm) return 1;
//       return 0;
//     });

//   return (
//     <div className="p-4">
//       <h2 className="text-2xl font-bold mb-4 text-center">Customer Details</h2>

//       <div className="flex justify-center mb-6">
//         <input
//           type="text"
//           placeholder="Search by Mobile Number"
//           value={searchTerm}
//           onChange={(e) => setSearchTerm(e.target.value)}
//           className="w-full max-w-md px-4 py-2 border rounded shadow focus:outline-none focus:ring"
//         />
//       </div>

//       {filteredCustomers.length === 0 ? (
//         <p className="text-center text-gray-500">No customers found.</p>
//       ) : (
//         <div className="overflow-x-auto">
//           <table className="min-w-full border border-gray-300 text-sm md:text-base">
//             <thead className="bg-blue-600 text-white">
//               <tr>
//                 <th className="py-2 px-4 border">S.No</th>
//                 <th className="py-2 px-4 border">Name</th>
//                 <th className="py-2 px-4 border">Mobile</th>
//                 <th className="py-2 px-4 border">Total</th>
//                 <th className="py-2 px-4 border">Date</th>
//                 {/* <th className="py-2 px-4 border">Date</th> */}
//                 <th className="py-2 px-4 border">Address</th>
//               </tr>
//             </thead>
//             <tbody>
//               {filteredCustomers.map((cust, index) => (
//                 <tr key={cust.id} className="hover:bg-blue-50">
//                   <td className="py-2 px-4 border text-center">{index + 1}</td>
//                   <td className="py-2 px-4 border">{cust.customer_name}</td>
//                   <td className="py-2 px-4 border">{cust.customer_mobile}</td>
//                   <td className="py-2 px-4 border">₹{cust.total}</td>
//                   <td className="py-2 px-4 border">{cust.order_date}</td>
//                   {/* <td className="py-2 px-4 border">{cust.date}</td> */}
//                   <td className="py-2 px-4 border">{cust.customer_address}</td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>
//       )}
//     </div>
//   );
// }

import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { Api } from "../Api/Api";

export default function CustomerDetails() {
  const [customers, setCustomers] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [editingCustomer, setEditingCustomer] = useState(null);

  const fetchCustomers = () => {
    axios
      .get(`${Api}retail/retail_get.php`)
      .then((res) => {
        setCustomers(Array.isArray(res.data) ? res.data : []);
        console.lo(res.data);
      })

      .catch((err) => {
        console.error("Failed to fetch data:", err);
      });
  };

  useEffect(() => {
    fetchCustomers();
  }, []);

  // ✅ DELETE
  // const handleDelete = (orderId) => {
  //   Swal.fire({
  //     title: "Are you sure?",
  //     text: "This order will be deleted permanently!",
  //     icon: "warning",
  //     showCancelButton: true,
  //     confirmButtonText: "Yes, delete it!",
  //   }).then((result) => {
  //     if (result.isConfirmed) {
  //       axios
  //         .post(`${Api}retail/retail_delete.php`, {
  //           order_id: orderId,
  //         })
  //         .then((res) => {
  //           if (res.data.status === "success") {
  //             Swal.fire("Deleted!", res.data.message, "success");
  //             fetchCustomers();
  //           } else {
  //             Swal.fire("Error!", res.data.message, "error");
  //           }
  //         });
  //     }
  //   });
  // };
  const handleDelete = async (orderId) => {
    // Step 1: Ask for confirmation
    const confirmResult = await Swal.fire({
      title: "Are you sure?",
      text: "This order will be deleted permanently!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, continue",
    });

    if (!confirmResult.isConfirmed) return;

    // Step 2: Ask for admin credentials
    const { value: credentials } = await Swal.fire({
      title: "Admin Verification Required",
      html: `
      <input type="text" id="swal-username" class="swal2-input" placeholder="Admin Username" />
      <input type="password" id="swal-password" class="swal2-input" placeholder="Admin Password" />
    `,
      focusConfirm: false,
      showCancelButton: true,
      confirmButtonText: "Verify & Delete",
      preConfirm: () => {
        const username = document.getElementById("swal-username").value;
        const password = document.getElementById("swal-password").value;

        if (!username || !password) {
          Swal.showValidationMessage("Please enter both username and password");
          return false;
        }

        return { username, password };
      },
    });

    if (!credentials) return;

    try {
      // Step 3: Verify admin credentials
      const verifyRes = await axios.post(`${Api}admin/login.php`, {
        username: credentials.username,
        password: credentials.password,
      });

      if (!verifyRes.data || !verifyRes.data.token) {
        Swal.fire("Error!", "Invalid admin credentials!", "error");
        return;
      }

      // Step 4: Proceed to delete the order
      const res = await axios.post(`${Api}retail/retail_delete.php`, {
        order_id: orderId,
      });

      if (res.data.status === "success") {
        Swal.fire("Deleted!", res.data.message, "success");
        fetchCustomers();
      } else {
        Swal.fire(
          "Error!",
          res.data.message || "Failed to delete order",
          "error"
        );
      }
    } catch (err) {
      console.error(err);
      Swal.fire("Error!", "Failed to verify admin or delete order.", "error");
    }
  };

  // ✅ EDIT (open SweetAlert form)
  const handleEdit = (cust) => {
    setEditingCustomer(cust);

    Swal.fire({
      title: "Edit Customer",
      html: `
        <input id="name" class="swal2-input" placeholder="Name" value="${cust.customer_name}" />
        <input id="mobile" class="swal2-input" placeholder="Mobile" value="${cust.customer_mobile}" />
        <input id="address" class="swal2-input" placeholder="Address" value="${cust.customer_address}" />
      `,
      focusConfirm: false,
      showCancelButton: true,
      preConfirm: () => {
        const name = document.getElementById("name").value;
        const mobile = document.getElementById("mobile").value;
        const address = document.getElementById("address").value;

        return { id: cust.id, name, mobile, address };
      },
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .post(`${Api}retail/retail_update.php`, result.value)
          .then((res) => {
            if (res.data.status === "success") {
              Swal.fire("Updated!", res.data.message, "success");
              fetchCustomers();
            } else {
              Swal.fire("Error!", res.data.message, "error");
            }
          })
          .catch(() =>
            Swal.fire("Error!", "Failed to update customer", "error")
          );
      }
    });
  };

  const filteredCustomers = customers
    .filter((cust) =>
      cust.customer_mobile?.toLowerCase().includes(searchTerm.toLowerCase())
    )
    .sort((a, b) => {
      if (a.customer_mobile === searchTerm) return -1;
      if (b.customer_mobile === searchTerm) return 1;
      return 0;
    });

  return (
    <div className="p-4">
      <h2 className="text-2xl font-bold mb-4 text-center">Customer Details</h2>

      <div className="flex justify-center mb-6">
        <input
          type="text"
          placeholder="Search by Mobile Number"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="w-full max-w-md px-4 py-2 border rounded shadow focus:outline-none focus:ring"
        />
      </div>

      {filteredCustomers.length === 0 ? (
        <p className="text-center text-gray-500">No customers found.</p>
      ) : (
        <div className="overflow-x-auto">
          <table className="min-w-full border border-gray-300 text-sm md:text-base">
            <thead className="bg-green-600 text-white">
              <tr>
                <th className="py-2 px-4 border">S.No</th>
                <th className="py-2 px-4 border">Name</th>
                <th className="py-2 px-4 border">Mobile</th>
                <th className="py-2 px-4 border">Total</th>
                <th className="py-2 px-4 border">Date</th>
                <th className="py-2 px-4 border">Address</th>
                <th className="py-2 px-4 border">Actions</th>
              </tr>
            </thead>
            <tbody>
              {filteredCustomers.map((cust, index) => (
                <tr key={cust.id} className="hover:bg-blue-50">
                  <td className="py-2 px-4 border text-center">{index + 1}</td>
                  <td className="py-2 px-4 border">{cust.customer_name}</td>
                  <td className="py-2 px-4 border">{cust.customer_mobile}</td>
                  <td className="py-2 px-4 border">₹{cust.total}</td>
                  <td className="py-2 px-4 border">{cust.order_date}</td>
                  <td className="py-2 px-4 border">{cust.customer_place}</td>
                  <td className="py-2 px-4 border text-center">
                    <div className="flex items-center justify-center gap-2">
                      <button
                        onClick={() => handleEdit(cust)}
                        className="bg-blue-500 text-white px-3 py-1 rounded hover:bg-yellow-600"
                      >
                        Edit
                      </button>
                      <button
                        onClick={() => handleDelete(cust.id)}
                        className="bg-red-500 text-white px-3 py-1 rounded hover:bg-red-600"
                      >
                        Delete
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
